<template>
  <el-card :body-style="{ padding: '10px', fontSize: '14px' }" >
    <div class="fl">
      <div class="fl-center" style="flex: 1;margin-right: 8px">
        <img v-if="type == 'doc'" class="doc" src="@img/login/doc.png">
        <img v-if="type == 'video'" class="video" src="@img/login/video.png">
      </div>
      <div class="contain" style="flex: 2;">
        <div>{{title}}</div>
        <div class="i" style="margin-top: 20px">
          <!-- <el-link style="margin-right: 10px" :href="look" target="_blank" type="primary"><i class="el-icon-view"></i>预览</el-link> -->
          <el-link v-if="type == 'doc'" :href="download" target="_blank" type="primary"><i class="el-icon-download"></i>下载</el-link>
          <el-link v-if="type == 'video'" :href="download" target="_blank" type="primary"><i class="el-icon-video-play"></i>播放</el-link>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  props: {
    title: String,
    download: String,
    look: String,
    type: {
      type: String,
      default: 'doc'
    }
  },
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    showVideo () {
      this.$emit('click', this.download, this.title)
    }
  }
}
</script>

<style scoped>
  .video {
    width: 40Px;
    height: 40Px;
  }
  .doc {
    width: 50Px;
    height: 40Px;
  }
  .el-card {
    width: 260Px !important;
    margin-bottom: 20Px;
  }
  .contain {
    position: relative;
    height: 78Px;
  }
  .i {
    position: absolute;
    bottom: 0Px;
  }
</style>



// WEBPACK FOOTER //
// src/Util/DataCard.vue